import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { StockCountsPage } from "src/components/views/erp/warehouse/stockCount/StockCountsPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/warehouse/inventory/stockCounts")({
	staticData: { title: i18n.t("stock_counts"), legacyViewKey: "stockCountsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <StockCountsPage />;
}
